export const Colors = {
    green:'rgb(210 242 152)',
    blue:'blue',
    buttonColor:'#4f2d7f',
    buttonDisabledColor:'rgb(204, 207, 210)',
    white:'#fff',
    red:'red',
    grey :'#bbbdc2',

}